<template>
  <v-card>
    <v-card-actions class="d-flex flex-row-reverse">
      <v-dialog v-model="dialog" persistent max-width="600px">
        <template v-slot:activator="{ on }">
          <v-btn 
            color="primary" 
            rounded dark 
            v-on="on"
            style="margin: 10px"
          >
            Create new
           </v-btn>
        </template>
        <app-element-input 
          @close="dialog = false"
          @save="closeDialog"
          :mappingSpecs="mappingSpecs"
        />
      </v-dialog>
    </v-card-actions>
    <v-card-text>

      <v-container fluid>
        <app-overlay
          :loading="loading"
        />
        <app-mapping-select 
          :selects="selects"
          :datas="datas"
          :type="mappingSpecs.type"
        />
        
      </v-container>
    </v-card-text>
    <v-card-actions class="d-flex flex-row-reverse">
      <v-btn 
        @click="submit"
        rounded color="success" 
        style="margin: 10px"
        :loading="submitLoading"
        :disabled="submitLoading"
      >
        Save
      </v-btn>
    </v-card-actions>
  </v-card>
</template>


<script>
  import axios from 'axios'
  import MappingSelect from './MappingSelect.vue'
  import Overlay from './../common/Overlay.vue'
  import ElementInput from './ElementInput.vue'
  export default {
    components: {
      AppMappingSelect : MappingSelect,
      AppOverlay: Overlay,
      AppElementInput: ElementInput
    },
    props: ['mappingSpecs'],
    data(){
      return {
        selects: [],
        datas: [],
        submitLoading: false,
        loading: false,
        dialog: false
      }
    },
    created(){
      this.getDataFromApi()
    },
    watch:{
      mappingSpecs(){
        this.getDataFromApi()
      }
    },
    methods: {
      closeDialog(){
        this.dialog = false
        this.getDataFromApi()
      },
      async getDataFromApi() {
        this.loading = true
        const request = {
          type : this.mappingSpecs.apiEndPoint,
          action : "index",
        };
        try {
          const accessToken = await this.$auth.getAccessToken()
          const response = await axios.post('/', JSON.stringify(request),{ headers: {Authorization: `Bearer ${accessToken}`}})
          this.selects = response.data.select
          this.datas = response.data.data
          this.loading = false
        } catch (e) {
          this.$router.push("/login")
          console.error(e)
          this.loading = false  
        }
      },
      async submit(){
        this.submitLoading = true
        const request = {
          type : this.mappingSpecs.apiEndPoint,
          action : "save",
          data: this.datas
        }
        try {
          const accessToken = await this.$auth.getAccessToken()
          await axios.post('/', JSON.stringify(request),{ headers: {Authorization: `Bearer ${accessToken}`}})
          this.submitLoading = false
        } catch (e) {
          this.$router.push("/login")
          console.error(e)
          this.submitLoading = false  
        }
      },
    }
  }
</script>